import { redirectToLogout } from "common/SharedFn";

const LogoutRoute = ({ match }) => {
  localStorage.setItem("token", null);
  localStorage.setItem("username", null);
  localStorage.setItem("userId", null);
  localStorage.setItem("userRole", null);
  localStorage.setItem("perItemServiceId", null);
  redirectToLogout();
}; 


export default LogoutRoute;
